import React, { useState, useEffect } from "react";
import { VscChromeClose } from "react-icons/vsc";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import * as FaIcons from "react-icons/fa";

import Favicon from "../assets/img/logo/griyasa-logo-only.svg";
import EngFlag from "../assets/img/flag-english.png";
import IndFlag from "../assets/img/flag-indonesia.png";

const lngs = {
    en: { nativeName: 'EN', icon: EngFlag, alt: 'English Flag' },
    id: { nativeName: 'ID', icon: IndFlag, alt: 'Indonesian Flag' }
};

function Navbar() {
    const { t, i18n } = useTranslation();
    const [sidebar, setSidebar] = useState(false);
    const [flag, setFlag] = useState("");

    useEffect(() => {
        const reloadCount = sessionStorage.getItem('reloadCount');
        if (reloadCount < 1) {
            sessionStorage.setItem('reloadCount', String(reloadCount + 1));
            window.location.reload();
        } else {
            sessionStorage.removeItem('reloadCount');
        }
        onSelectedNavbar(window.location.pathname);
        onSelectedFlag('en');
    }, []);

    const navbarList = [
        { menu: t('home'), path: '/' },
        { menu: t('about-us'), path: '/about-us' },
        { menu: t('our-team'), path: '/our-team' },
        { menu: t('gallery'), path: '/gallery' },
        { menu: t('contact-us'), path: '/contact-us' }
    ];

    function showSidebar() {
        setSidebar(!sidebar);
    }

    function checkIcon() {
        if (!sidebar) {
            return <FaIcons.FaBars onClick={showSidebar} />
        } else {
            return <VscChromeClose onClick={showSidebar} />
        }
    }

    function onSelectedNavbar(param) {
        window.scrollTo(0, 0);

        document.getElementById("home").className = "";
        document.getElementById("about-us").className = "";
        document.getElementById("our-team").className = "";
        document.getElementById("gallery").className = "";
        document.getElementById("contact-us").className = "";

        if (param === "/") {
            document.getElementById("home").className = "active";
        }
        if (param === "/about-us") {
            document.getElementById("about-us").className = "active";
        }
        if (param === "/our-team") {
            document.getElementById("our-team").className = "active";
        }
        if (param === "/gallery") {
            document.getElementById("gallery").className = "active";
        }
        if (param === "/contact-us") {
            document.getElementById("contact-us").className = "active";
        }
    }

    function onSelectedFlag(param) {
        setFlag(param);
    }

    return (
        <>
            <nav>
                <div className='logo'>
                    <Link to="/" onClick={() => onSelectedNavbar("/")}><img src={Favicon} alt="Logo Griyasa Teal" /></Link>
                </div>

                <div className='list-navbar hidden md:flex md:items-center md:justify-center'>
                    <Link id="home" to="/" onClick={() => onSelectedNavbar("/")}>{t('home')}</Link>
                    <Link id="about-us" to="/about-us" onClick={() => onSelectedNavbar("/about-us")}>{t('about-us')}</Link>
                    <Link id="our-team" to="/our-team" onClick={() => onSelectedNavbar("/our-team")}>{t('our-team')}</Link>
                    <Link id="gallery" to="/gallery" onClick={() => onSelectedNavbar("/gallery")}>{t('gallery')}</Link>
                    <Link id="contact-us" to="/contact-us" onClick={() => onSelectedNavbar("/contact-us")}>{t('contact-us')}</Link>
                </div>

                <div className='translate hidden md:grid md:grid-cols-2'>
                    {Object.keys(lngs).map((lng) => (
                        <a id={lng} key={lng} href={'#' + lngs[lng].nativeName} className={`flag-group ${lng === flag ? 'active' : ''}`}
                            onClick={() => { i18n.changeLanguage(lng); onSelectedFlag(lng); }}
                            disabled={i18n.resolvedLanguage === lng}>
                            <img src={lngs[lng].icon} alt={lngs[lng].alt} />
                            <p>{lngs[lng].nativeName}</p>
                        </a>
                    ))}
                </div>

                <div className="grid md:hidden">
                    {/* <p>kosong</p> */}
                </div>
                <div className="grid justify-end mr-8 md:hidden">
                    {/*burger*/}
                    <Link to="#" className='flex menu-bars my-auto hover:bg-[white] hover:text-[#A2CD3A] active:bg-[white] active:text-[#A2CD3A] focus:bg-[white] focus:text-[#A2CD3A]'>
                        {checkIcon()}
                    </Link>
                </div>
            </nav>

            <nav className={!sidebar ? 'hidden' : 'nav-burger-show'}>
                {navbarList.map((item, i) => (
                    <Link key={i} to={item.path} onClick={() => { onSelectedNavbar(item.path); showSidebar() }} className={"navbar-item"}>
                        <div className={"item"}>
                            {item.menu}
                        </div>
                    </Link>
                ))}
                <div className='translate grid grid-cols-2' style={{ margin: 0, width: '80%' }}>
                    {Object.keys(lngs).map((lng) => (
                        <a id={lng + 2} key={lng} href={'#' + lngs[lng].nativeName} className={`flag-group ${lng === flag ? 'active' : ''}`} style={{ height: '2em' }}
                            onClick={() => { i18n.changeLanguage(lng); onSelectedFlag(lng); showSidebar(); }}
                            disabled={i18n.resolvedLanguage === lng}>
                            <img src={lngs[lng].icon} alt={lngs[lng].alt} />
                            <p>{lngs[lng].nativeName}</p>
                        </a>
                    ))}
                </div>
            </nav>
        </>
    );
}

export default Navbar;